import React, { useRef, useLayoutEffect, useMemo } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
var MyGlobalObject = {}

function AreaChart(props) {
    const chart = useRef(null);
    const root = useRef(null);
    const series = useRef(null);
    const id = props.id;
    const div = props.div;
    const isInitialized = useRef(false);

    const memoizedData = useMemo(() => props.value, [JSON.stringify(props.value)]);

    // Initialize chart once
    useLayoutEffect(() => {
        if (isInitialized.current) return;

        const r = am5.Root.new(div);
        root.current = r;

        if (MyGlobalObject[id]) {
            MyGlobalObject[id].dispose()
        }

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        const chart = r.container.children.push(
            am5xy.XYChart.new(r, {
                focusable: true,
                panX: false,
                panY: false,
                //wheelX: "panX",
                //wheelY: "zoomX"
            })
        );

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        /*
        const xAxis = chart.xAxes.push(
            am5xy.DateAxis.new(r, {
            maxDeviation: 0.1,
            groupData: false,
            baseInterval: {
                timeUnit: "day",
                count: 1
            },
            renderer: am5xy.AxisRendererX.new(r, {
                minGridDistance: 50
            }),
            tooltip: am5.Tooltip.new(r, {})
            })
        );
        */

        const xAxis = chart.xAxes.push(
            am5xy.DateAxis.new(r, {
                maxDeviation: 0,
                groupData: false,
                baseInterval: {
                    timeUnit: "second",
                    count: 10
                },
                renderer: am5xy.AxisRendererX.new(r, {
                    minGridDistance: 80,
                    maxGridDistance: 120
                }),
                tooltip: am5.Tooltip.new(r, {})
            })
        );

        const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(r, {
                min: 0,
                max: 100,
                strictMinMax: true,
                maxDeviation: 0,
                renderer: am5xy.AxisRendererY.new(r, {})
            })
        );

        // Add series
        const seriesInstance = chart.series.push(
            am5xy.LineSeries.new(r, {
                minBulletDistance: 10,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "value",
                valueXField: "time",
                tooltip: am5.Tooltip.new(r, {})
            })
        );
        series.current = seriesInstance;
/*
        series.bullets.push(function (r) {
            return am5.Bullet.new(r, {
                sprite: am5.Circle.new(r, {
                    radius: 5,
                    fill: series.get("fill"),
                    stroke: r.interfaceColors.get("background"),
                    strokeWidth: 2,
                    tooltipText: '{valueX.formatDate()} : {valueY}'
                })
            });
        });
*/
        // Set up data processor to parse string dates
        // https://www.amcharts.com/docs/v5/concepts/data/#Pre_processing_data

        // series.data.processor = am5.DataProcessor.new(r, {
        //     dateFormat: "yyyy-MM-dd",
        //     dateFields: ["date"]
        // });
        seriesInstance.data.setAll(memoizedData);

        seriesInstance.data.processor = am5.DataProcessor.new(r, {
            dateFormat: "yyyy-MM-DD HH:mm:ss",
            dateFields: ["date"]
        });


        //r.durationFormatter.set("durationFormat", "mm:ss");

        // const getDate = (timestamp) => {
        //     const date = new Date(timestamp)
        //     return date
        // }


        const tooltip = am5.Tooltip.new(r, {
            pointerOrientation: "horizontal"
        });
        tooltip.label.set("text", "{valueY}");
        seriesInstance.set("tooltip", tooltip);
        
        // Disable animations to prevent axis jerking
        seriesInstance.set("animationDuration", 0);
        chart.set("animationDuration", 0);
        xAxis.set("animationDuration", 0);
        yAxis.set("animationDuration", 0);

        /* 
        */

        // Add cursor
        // chart.set("cursor", am5xy.XYCursor.new(r, {
        //     maxTooltipDistance: -1
        // }));

        chart.set("cursor", am5xy.XYCursor.new(r, {
            xAxis: xAxis,
            yAxis: yAxis,
            snapToSeries: [seriesInstance]
        }));
          
        xAxis.set("tooltip", am5.Tooltip.new(r, {
            themeTags: ["axis"],
            tooltipText: '{valueX.formatDate()}'
        }));
          
        yAxis.set("tooltip", am5.Tooltip.new(r, {
            themeTags: ["axis"]
        }));

        MyGlobalObject[id] = r
        isInitialized.current = true;

        return () => {
            if (root.current) {
                root.current.dispose();
                isInitialized.current = false;
            }
        };
    }, []);

    // Update data when it changes
    useLayoutEffect(() => {
        if (!isInitialized.current || !series.current || !memoizedData?.length) {
            return;
        }
        series.current.data.setAll(memoizedData);
    }, [memoizedData]);
    return (
        <div id={div} style={{ width: "100%", height: "300px" }}></div>
    );

}

export default AreaChart;